package com.solevo.dist.network.api.notifications

import com.solevo.dist.application.models.Notification
import com.solevo.dist.application.models.NotificationType
import com.solevo.dist.network.infrastructure.utils.DefaultRemoteSourceImplementationException
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow

interface NotificationRemoteSource {
    fun getNotification(id: String): Flow<Notification?> = flow { throw DefaultRemoteSourceImplementationException() }
    fun getNotificationsLive(limit: Int, type: NotificationType? = null): Flow<List<Notification>> = flow { throw DefaultRemoteSourceImplementationException() }
    fun checkUnreadNotifications(): Flow<Boolean> = flow { throw DefaultRemoteSourceImplementationException() }
    suspend fun updateNotification(id: String, data: Map<String, Any>): Result<Unit> = Result.failure(DefaultRemoteSourceImplementationException())
}